export default "__VITE_ASSET__Dj7$zRbw__"